import { ThemeColors } from '~/themes/colors'

export interface CallCenterSettingsColors {
  CustomStatus: {
    Container: {
      Border: ThemeColors
      Background: ThemeColors
    }
    StatusIndicator: {
      Away: ThemeColors
      Online: ThemeColors
    }
    Title: {
      Color: ThemeColors
    }
    Description: {
      Color: ThemeColors
    }
  }
}

export const callCenterSettingsColors: CallCenterSettingsColors = {
  CustomStatus: {
    Container: {
      Border: {
        default: 'gray.600',
      },
      Background: {
        default: 'gray.100',
      },
    },
    StatusIndicator: {
      Away: {
        default: 'red.700',
      },
      Online: {
        default: 'blue.700',
      },
    },
    Title: {
      Color: {
        default: 'gray.1300',
      },
    },
    Description: {
      Color: {
        default: 'gray.800',
      },
    },
  },
}
